import { render, staticRenderFns } from "./b23.vue?vue&type=template&id=151c118d&scoped=true"
import script from "./b23.vue?vue&type=script&lang=js"
export * from "./b23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c118d",
  null
  
)

export default component.exports